const PageAgenciesCatalogClassName = '.page-agencies-catalog__right';
document.querySelectorAll(PageAgenciesCatalogClassName).forEach((el) => {
    const classActive = `${PageAgenciesCatalogClassName}--active`.replace('.', '');

    el.querySelector(`${PageAgenciesCatalogClassName}-toggle`).addEventListener('click', () => {
        el.classList.add(classActive);
        document.body.classList.add('modal-open');
    });
});
